import { Delegate } from "@bonusmap/shared_ui/library";
import { BaseWebComponent } from "../../base-components/base-web-component.js";
import { DataCollector } from "../data-collector.js";
export interface CollectorExtensionInterface {
    documentBodyDelegate: Delegate;
    onCollectorReady(): void;
    onDataCollect(data: Record<string, any>): Record<string, any>;
}
export abstract class CollectorExtensionBase extends BaseWebComponent implements CollectorExtensionInterface {
    static webComponentName: string = "collector-extension-base";
    static observedAttributes = []; // Nessun attributo da osservare per ora
    protected _templateId: string = ""; // No template, estensione logica
    protected collector!: DataCollector;
    documentBodyDelegate: Delegate
    constructor() {
        super();
        this.documentBodyDelegate = new Delegate(document.body);
    }
    onCollectorReady(): void {
        // Metodo chiamato quando il collector è pronto
        console.log("CollectorExtensionBase: onCollectorReady chiamato");
    }
    onDataCollect(data: Record<string, any>): Record<string, any> {
        // qui posso modificare i dati raccolti prima che vengano inviati
        return data;
    }
    protected onConnected(): void {
        this.collector = document.querySelector('data-base-collector') as DataCollector;
        if (!this.collector) {
            console.warn("CollectorExtensionBase: DataCollector non trovato nel DOM");
            return;
        }
        this.collector.collectorExtension = this;
        this.onCollectorReady();
        console.log("CollectorExtensionBase connesso al DOM");

        document.addEventListener('data-collect', (event: CustomEvent) => {
            let data: Record<string, any> = event.detail.data;
            // qui posso modificare i dati raccolti prima che vengano inviati
            data = this.onDataCollect(data);
            console.log("Dati raccolti modificati", data);
            event.detail.data = data; // aggiorno i dati nell'evento
        });
    }
    protected render(): void {
        // Nessun rendering necessario per questa estensione
    }
    static onRegistered() {
        console.log(`${this.webComponentName} registered`);
    }
    static registerElement() {
        super.registerElement();
        if(document.querySelector(this.webComponentName) ) {
            this.onRegistered();
        }
    }
}